export default {
  'deliveryOrReturnOfMaterials.create.confirmDelivery': 'Confirmar entrega',
  'deliveryOrReturnOfMaterials.create.confirmedDevolution':
    'Confirmar Devolução',
  'deliveryOrReturnOfMaterials.create.returnMaterial': 'Devolver Material',
  'deliveryOrReturnOfMaterials.create.deliverMaterial': 'Entregar Material',

  'deliveryOrReturnOfMaterials.columns.table.company': 'Empresa',
  'deliveryOrReturnOfMaterials.columns.table.deliveredOrReturnedBy':
    'Entregue/Devolvido por:',
  'deliveryOrReturnOfMaterials.columns.table.receivedBy': 'Recebido por:',
  'deliveryOrReturnOfMaterials.columns.table.date': 'Data',
  'deliveryOrReturnOfMaterials.columns.table.deliveryOrReturn':
    'Entrega/Devolução',

  'deliveryOrReturnOfMaterials.deliverMaterial.form.deliveryData':
    'Data da Entrega',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.company': 'Empresa',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.deliveredBy':
    'Entregue por',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.receivedBy': 'Recebido por',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.button.includeParts':
    'Incluir Peças',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.button.includeConsumablesCv':
    'Incluir Insumos CV',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.button.includeConsumablesSv':
    'Incluir Insumos SV',

  'deliveryOrReturnOfMaterials.deliverMaterial.TitleTable.itemsToDeliver':
    'Itens a Entregar',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.workOrder': 'O.S',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.description':
    'Descrição',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.manufacturerCode':
    'Cód. Fabricante',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.type': 'Tipo',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.qtyRequested':
    'Qtde. Solicitada',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.qtyDelivered':
    'Qtde. Entregue',

  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.title':
    'Selecionar Insumos',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.budget':
    'Orçamento',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.os': 'O.S',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.description':
    'Descrição',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.manufacturerCode':
    'Cód Fabricante',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.board': 'Placa',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.requestedQuantity':
    'Qtde. Solicitada',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.availableQuantity':
    'Qtde. Disponível',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.provided':
    'Fornecida',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.deliveryQuantity':
    'Qtde. Entrega',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.estimator':
    'Orçamentista',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.authorizationDate':
    'Data de Autorização',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.area': 'Área',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.costPrice':
    'Preço de Custo',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.stock': 'Estoque',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.internalCode':
    'Código Interno',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.dateReturn':
    'Data Devolução',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.type': 'Tipo',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.returnedQuantity':
    'Quantidade Devolvida',
  'deliveryOrReturnOfMaterials.deliverMaterial.modalDelivery.licensePlate':
    'Placa',

  'deliveryOrReturnOfMaterials.returnMaterial.form.dateOfReturn':
    'Data da devolução:',
  'deliveryOrReturnOfMaterials.returnMaterial.form.company': 'Empresa',
  'deliveryOrReturnOfMaterials.returnMaterial.form.returnedBy':
    'Devolvido por:',
  'deliveryOrReturnOfMaterials.returnMaterial.form.receivedBy': 'Recebido por:',
  'deliveryOrReturnOfMaterials.returnMaterial.form.display': 'Exibir',
  'deliveryOrReturnOfMaterials.returnMaterial.form.display.part':
    'Somente Peças',
  'deliveryOrReturnOfMaterials.returnMaterial.form.display.consumable':
    'Somente Insumos',

  'deliveryOrReturnOfMaterials.returnMaterial.table.column.workOrder': 'O.S',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.description':
    'Descrição',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.licensePlate':
    'Placa',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.delivery': 'Entrega',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.manufacturer':
    'Fabricante',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.qtyReturned':
    'Qtde. Devolvida',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.qtyDelivered':
    'Qtde. Entregue',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.qtyGiveBack':
    'Qtde. Devolver',
};
